"use client";

import { useEffect, useState } from "react";
import { cn } from "@/lib/cn";

interface DueBadgeProps {
  size?: "sm" | "md";
  className?: string;
}

export function DueBadge({ size = "md", className }: DueBadgeProps) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    fetch("/api/stats/cards-due")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.count != null) setCount(data.count);
      })
      .catch(() => {});
  }, []);

  if (count === 0) return null;

  const label = count > 99 ? "99+" : String(count);

  return (
    <span
      className={cn(
        "flex items-center justify-center rounded-full bg-safety-orange border border-border-thick font-bold text-white",
        size === "sm"
          ? "min-w-[16px] h-[16px] text-[9px] px-0.5"
          : "min-w-[18px] h-[18px] text-[10px] px-1",
        className
      )}
    >
      {label}
    </span>
  );
}
